import { firestore } from '../firebase'
import {
  ON_PRODUCTS_CHANGE,
  REQUEST_PRODUCTS
} from './types'

import {idNumber} from '../share/id_helper'
import {confirm} from '../components/dialogs'

const onProductsChange = (updates) => ({ type: ON_PRODUCTS_CHANGE, updates })
const requestProducts = () => ({type: REQUEST_PRODUCTS})

export const listenForProductsChanges = () =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) throw new Error("Unknown Account")

    dispatch(requestProducts())
    return firestore.collection('accounts').doc(account.currentAccountId)
      .collection('products')
      .onSnapshot( snapshot => {
        const updates = { added: [], removed: [], modified: [] }

        snapshot.docChanges().forEach( change => {
          if(updates[change.type]) updates[change.type].push(
            {...change.doc.data(), id:change.doc.id}
          )
        })

        dispatch(onProductsChange(updates))
      }, error => console.log('ERROR:::::',error))
  }

  export const createProduct = (data) =>
    (dispatch, getState) => {
      const state = getState()
      if(!state.account || !state.account.currentAccountId ||
         !data.name || data.name.length === 0) return Promise.resolve(null)
      // check redux if product already exists
      const index = state.products.items.findIndex(p =>
        p.name === data.name && p.description === data.description
      )
      // return a promise with client if found
      if(index >= 0) return Promise.resolve(state.products.items[index])

      // create new entry for client
      const newProductRef = firestore.collection('accounts')
                                     .doc(state.account.currentAccountId)
                                     .collection('products')
                                     .doc()
      // generate number and set createdAt
      const now = Date.now()
      const product = {...data,
        id: newProductRef.id,
        createdAt: now,
        number: idNumber(newProductRef.id,now)
      }
      // write to database and return promise with the new client
      return newProductRef.set(product).then(() => product)
    }


export const updateProduct = (product) =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) return
    return firestore.collection('accounts')
                    .doc(account.currentAccountId)
                    .collection('products')
                    .doc(product.id)
                    .set(product,{ merge: true })
  }

export const deleteProduct = (productId) =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) return
    return confirm('Damit wird dieses Produkt gelöscht!',{confirmLabel: 'Ok',abortLabel: 'Abbrechen'}).then(() =>
      firestore.collection('accounts')
                      .doc(account.currentAccountId)
                      .collection('products')
                      .doc(productId)
                      .delete()
    ).catch(error => console.log('ERROR::::',error))
  }



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/actions/products.js